type SectionIntroProps = {
  eyebrow?: string;
  title: string;
  description: string;
};

export function SectionIntro({ eyebrow, title, description }: SectionIntroProps) {
  return (
    <div className="section-intro">
      {eyebrow ? <div className="eyebrow section-intro-eyebrow">{eyebrow}</div> : null}
      <div className="section-intro-copy">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
}
